/* ==========================================================================
   PDP v2 — behaviour for the pdp-* sections.
   Vanilla, no jQuery. Each initialiser is idempotent and re-runnable so the
   theme editor can call window.PDP.init(container) after a section reload.
   ========================================================================== */
(function () {
  'use strict';

  var CART_CHANGED = 'theme:cartchanged';

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* --- Carousels ------------------------------------------------------- */
  function initCarousels(root) {
    $$('[data-pdp-carousel]', root).forEach(function (car) {
      if (!once(car, 'pdpCarousel')) return;
      var track = car.querySelector('[data-pdp-track]');
      if (!track) return;

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 1;
        $$('[data-pdp-prev]', car).forEach(function (b) { b.disabled = track.scrollLeft <= 1; });
        $$('[data-pdp-next]', car).forEach(function (b) { b.disabled = track.scrollLeft >= max; });
      }
      $$('[data-pdp-prev]', car).forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      });
      $$('[data-pdp-next]', car).forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* --- Accordions ------------------------------------------------------ */
  function initAccordions(root) {
    $$('[data-pdp-acc]', root).forEach(function (acc) {
      if (!once(acc, 'pdpAcc')) return;
      var single = acc.hasAttribute('data-pdp-acc-single');
      $$('[data-pdp-acc-trigger]', acc).forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var panel = document.getElementById(trigger.getAttribute('aria-controls'));
          var open = trigger.getAttribute('aria-expanded') === 'true';
          if (single && !open) {
            $$('[data-pdp-acc-trigger]', acc).forEach(function (other) {
              other.setAttribute('aria-expanded', 'false');
              var p = document.getElementById(other.getAttribute('aria-controls'));
              if (p) p.removeAttribute('data-open');
            });
          }
          trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (panel) { open ? panel.removeAttribute('data-open') : panel.setAttribute('data-open', ''); }
        });
      });
    });
  }

  /* --- Disclosures ------------------------------------------------------ *
   * The promo bar's ? and the two guarantees. Both open a panel named by
   * aria-controls; the guarantee row additionally steps aside for its panel,
   * which is how the mock shows it.                                         */
  function initDisclosures(root) {
    function close(btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    }

    $$('[data-pdp-disclosure]', root).forEach(function (btn) {
      if (!once(btn, 'pdpDisclosure')) return;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        var group = btn.closest('[data-pdp-guarantees]');
        // One panel at a time: they all land in the same slot.
        if (!open && group) {
          $$('[data-pdp-disclosure]', group).forEach(function (other) {
            if (other !== btn) close(other);
          });
        }
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
        syncGuarantees(group);
      });
    });

    $$('[data-pdp-disclosure-close]', root).forEach(function (btn) {
      if (!once(btn, 'pdpDisclosureClose')) return;
      btn.addEventListener('click', function () {
        var panel = btn.closest('[data-pdp-panel]');
        if (!panel) return;
        panel.hidden = true;
        var opener = document.querySelector('[aria-controls="' + panel.id + '"]');
        if (opener) opener.setAttribute('aria-expanded', 'false');
        syncGuarantees(btn.closest('[data-pdp-guarantees]'));
      });
    });
  }

  /* The row and its panels share one slot, so only one of them shows. */
  function syncGuarantees(group) {
    if (!group) return;
    var row = group.querySelector('[data-pdp-guarantee-row]');
    if (!row) return;
    var open = group.querySelector('[data-pdp-panel]:not([hidden])');
    row.hidden = !!open;
  }

  /* --- Quantity steppers ----------------------------------------------- */
  function initQty(root) {
    $$('[data-pdp-qty]', root).forEach(function (wrap) {
      if (!once(wrap, 'pdpQty')) return;
      var input = wrap.querySelector('[data-pdp-qty-input]');
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-pdp-qty-step]');
        if (!btn || !input) return;
        e.preventDefault();
        var next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.pdpQtyStep, 10);
        input.value = Math.max(1, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* --- Variant selection ----------------------------------------------- *
   * A form is the unit. It carries its variant table as JSON and the option
   * inputs name themselves by index, so this works for swatch+button pickers
   * (buy box) and select pickers (quick add / sticky bar) alike.            */
  function readOptions(form) {
    var out = [];
    $$('[data-pdp-option]', form).forEach(function (el) {
      var i = parseInt(el.dataset.pdpOption, 10);
      // A blank select is "not chosen yet", not a chosen empty value —
      // leaving the hole is what makes the button read "Select a size".
      if (el.tagName === 'SELECT') { if (el.value) out[i] = el.value; return; }
      if (el.checked) out[i] = el.value;
    });
    return out;
  }

  function matchVariant(variants, chosen) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      // Walk the variant's own options, not the chosen array — a partial
      // selection has holes and must not match on its first option alone.
      for (var j = 0; j < v.options.length; j++) {
        if (chosen[j] === undefined) { ok = false; break; }
        if (v.options[j] !== chosen[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  /* The media a variant shows. Most of this catalogue assigns no media to its
     variants, so featured_media_id is 0 and the buy box's swatch for that
     colour — its data-pdp-media resolved by name in pdp-swatches.liquid — is
     what actually carries it. Matched by value, not :checked, so it answers
     for the sticky bar's variant too.                                        */
  function variantMedia(v) {
    if (!v) return '';
    if (v.featured_media_id) return String(v.featured_media_id);
    var main = document.querySelector('.pdpm__card[data-pdp-form]');
    if (!main) return '';
    var swatch = $$('input[data-pdp-media]', main).filter(function (el) {
      return v.options[parseInt(el.dataset.pdpOption, 10)] === el.value;
    })[0];
    return swatch ? swatch.getAttribute('data-pdp-media') : '';
  }

  function paintPrice(el, v) {
    if (!v) return;
    var onSale = !!(v.compare_at_price && v.compare_at_price > v.price);
    var now = el.querySelector('[data-pdp-price-now]');
    var was = el.querySelector('[data-pdp-price-was]');
    if (now) {
      now.textContent = v.price_money;
      now.classList.toggle('pdp-price__now--sale', onSale);
    }
    if (was) {
      was.textContent = onSale ? v.compare_at_price_money : '';
      was.hidden = !onSale;
    }
  }

  function initForms(root) {
    // [data-pdp-form] is a wrapper; the real <form> lives inside it.
    $$('[data-pdp-form]', root).forEach(function (form) {
      if (!once(form, 'pdpForm')) return;
      var formEl = form.tagName === 'FORM' ? form : form.querySelector('form');
      var dataEl = form.querySelector('[data-pdp-variants]');
      if (!dataEl || !formEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = form.querySelector('[data-pdp-variant-id]');
      var submit = form.querySelector('[type="submit"]');
      var submitText = submit && submit.querySelector('[data-pdp-submit-text]');
      var strings = form.dataset.pdpStrings ? JSON.parse(form.dataset.pdpStrings) : {};
      // Only the buy card writes ?variant= — a quick-add row or the sticky bar
      // changing its own selects should not rewrite the page's address.
      var writesHistory = form.hasAttribute('data-pdp-history') &&
        typeof window.history !== 'undefined' && !!window.history.replaceState;

      function paint(fromUser) {
        var chosen = readOptions(form);
        var v = matchVariant(variants, chosen);
        var incomplete = chosen.filter(function (x) { return x !== undefined; }).length < variants[0].options.length;

        if (idInput) idInput.value = v ? v.id : '';

        // Selected-option read-outs, e.g. "Color: Oil Tan"
        $$('[data-pdp-option-value]', form).forEach(function (el) {
          var i = parseInt(el.dataset.pdpOptionValue, 10);
          el.textContent = chosen[i] || '';
        });

        // Price
        $$('[data-pdp-price]', form).forEach(function (el) { paintPrice(el, v); });

        // Low-stock note next to the size label
        $$('[data-pdp-stock]', form).forEach(function (el) {
          var low = v && v.available && v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5;
          el.hidden = !low;
        });

        // Submit state
        if (submit) {
          var label;
          if (incomplete) { label = strings.select || 'Select a size'; submit.disabled = true; }
          else if (!v) { label = strings.unavailable || 'Unavailable'; submit.disabled = true; }
          else if (!v.available) { label = strings.soldout || 'Sold out'; submit.disabled = true; }
          else { label = strings.add || 'Add to bag'; submit.disabled = false; }
          submit.classList.toggle('pdp-btn--disabled', submit.disabled);
          if (submitText) submitText.textContent = label;
        }

        // ?variant= on the address, the way the old product section did with
        // data-enable-history-state. replaceState, not pushState: stepping
        // through colours shouldn't fill the back button. Only on a real
        // change — the opening paint would otherwise rewrite the URL of a page
        // the visitor just landed on.
        if (fromUser && writesHistory && v) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({ path: url.href }, '', url.href);
          } catch (err) { /* older browsers keep the address they have */ }
        }

        form.dispatchEvent(new CustomEvent('pdp:variant', { bubbles: true, detail: { variant: v } }));
      }

      form.addEventListener('change', function (e) {
        if (e.target.closest('[data-pdp-option]') || e.target.matches('[data-pdp-option]')) paint(true);
      });
      paint();

      if (form.hasAttribute('data-pdp-ajax')) {
        formEl.addEventListener('submit', function (e) {
          e.preventDefault();
          if (submit) submit.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
            body: new URLSearchParams(new FormData(formEl))
          })
            .then(function (r) { return r.json(); })
            .then(function (item) {
              document.documentElement.dispatchEvent(new CustomEvent(CART_CHANGED, { bubbles: true, cancelable: false }));
              refreshCartCount();
              notifyAdded(item);
              if (submitText) {
                var prev = submitText.textContent;
                submitText.textContent = strings.added || 'Added';
                setTimeout(function () { submitText.textContent = prev; }, 2000);
              }
            })
            .catch(function () {})
            .then(function () { if (submit) submit.disabled = false; });
        });
      }
    });
  }

  /* The legacy header cart-count refresher targets Symmetry selectors that
     header-v2 does not use, so update the v2 badge directly. */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('.hv2-cart__count');
        if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; return; }
        var link = document.querySelector('.hv2-cart');
        if (link && cart.item_count > 0) {
          var span = document.createElement('span');
          span.className = 'hv2-cart__count';
          span.textContent = cart.item_count;
          link.appendChild(span);
        }
      })
      .catch(function () {});
  }

  /* --- Added-to-cart notification -------------------------------------- *
   * <pdp-cart-notification> — the first custom element in this file. The rest
   * of pdp.js is init functions over data-* hooks, which is the pattern the
   * theme already used; this is the shape to move the others to.
   *
   * The markup deliberately reuses Symmetry's .cart-summary-overlay class
   * names, so the 40 rules already in styles.css lay it out and it stays in
   * step if the theme's styling changes. What it does not reuse is the theme's
   * jQuery submit handler, which needs a ProductJson dump the sticky bar and
   * quick-add forms don't have — built here, all three get the same
   * confirmation.                                                          */
  function money(cents) {
    var t = window.theme;
    if (t && t.Shopify && typeof t.Shopify.formatMoney === 'function') {
      return t.Shopify.formatMoney(cents, t.money_format);
    }
    return (cents / 100).toFixed(2);
  }
  function str(key, fallback) {
    var t = window.theme;
    return (t && t.strings && t.strings[key]) || fallback;
  }

  if (typeof HTMLElement === 'function' && window.customElements && !customElements.get('pdp-cart-notification')) {
    customElements.define('pdp-cart-notification', class extends HTMLElement {
      connectedCallback() {
        this.hidden = true;
        this.addEventListener('click', function (e) {
          if (e.target.closest('[data-pdp-notify-close]')) { e.preventDefault(); this.close(); }
        }.bind(this));
        // The theme dismisses its own overlay on scroll; match that.
        this._onScroll = function () { if (!this.hidden) this.close(); }.bind(this);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
      }

      close() {
        this.hidden = true;
        window.removeEventListener('scroll', this._onScroll);
      }

      /* item: the /cart/add.js response. cart: the /cart.js response. */
      show(item, cart) {
        if (!item) return;
        var variants = '';
        if (item.variant_title && item.options_with_values) {
          item.options_with_values.forEach(function (o) {
            variants += '<div class="cart-summary-overlay__variant">' +
              '<span class="cart-summary-overlay__variant-option">' + esc(o.name) + '</span>' +
              '<span class="cart-summary-overlay__variant-value">' + esc(o.value) + '</span>' +
              '</div>';
          });
        }

        var unitHtml =
          (item.original_price > item.final_price
            ? '<div class="struck-out-price"><span class="theme-money">' + money(item.original_price) + '</span></div>'
            : '') +
          '<div><span class="theme-money">' + money(item.final_price) + '</span></div>';
        var lineHtml =
          (item.original_line_price > item.final_line_price
            ? '<div class="theme-money struck-out-price">' + money(item.original_line_price) + '</div>'
            : '') +
          '<span class="theme-money">' + money(item.final_line_price) + '</span>';

        this.innerHTML = [
          '<div class="cart-summary-overlay__row-head">',
            '<div class="cart-summary-overlay__column-image"><div class="cart-summary-overlay__column-title">', esc(str('products_added_notification_title', 'Added to cart')), '</div></div>',
            '<div class="cart-summary-overlay__column-item"><div class="cart-summary-overlay__column-title">', esc(str('products_added_notification_item', 'Item')), '</div></div>',
            '<div class="cart-summary-overlay__column-price-region">',
              '<div class="cart-summary-overlay__column-price"><div class="cart-summary-overlay__column-title">', esc(str('products_added_notification_unit_price', 'Price')), '</div></div>',
              '<div class="cart-summary-overlay__column-quantity"><div class="cart-summary-overlay__column-title">', esc(str('products_added_notification_quantity', 'Qty')), '</div></div>',
              '<div class="cart-summary-overlay__column-total"><div class="cart-summary-overlay__column-title">', esc(str('products_added_notification_total_price', 'Total')), '</div></div>',
            '</div>',
            '<div class="cart-summary-overlay__column-subtotal"><div class="cart-summary-overlay__column-title">', esc(str('products_added_notification_subtotal', 'Subtotal')), '</div></div>',
          '</div>',
          '<div class="cart-summary-overlay__row-body">',
            '<div class="cart-summary-overlay__column-image">',
              item.image ? '<img src="' + esc(item.image) + '" alt="" width="85" loading="lazy">' : '',
            '</div>',
            '<div class="cart-summary-overlay__column-item">',
              '<div class="cart-summary-overlay__title">', esc(item.product_title || ''), '</div>',
              '<div class="cart-summary-overlay__variants">', variants, '</div>',
              // Below 768 the theme hides the price columns and shows this row
              // instead; without it the notification loses its prices on a phone.
              '<div class="cart-summary-overlay__mobile-price-row">',
                '<div class="cart-summary-overlay__mobile-unit-price">', unitHtml, '</div>',
                '<div class="cart-summary-overlay__mobile-quantity">', esc(str('products_added_notification_quantity', 'Qty')),
                  '<span class="cart-summary-overlay__quantity">', item.quantity, '</span>',
                '</div>',
                '<div class="cart-summary-overlay__mobile-line-price">', lineHtml, '</div>',
              '</div>',
            '</div>',
            '<div class="cart-summary-overlay__column-price-region">',
              '<div class="cart-summary-overlay__column-price"><span class="cart-summary-overlay__unit-price">', unitHtml, '</span></div>',
              '<div class="cart-summary-overlay__column-quantity"><span class="cart-summary-overlay__quantity">', item.quantity, '</span></div>',
              '<div class="cart-summary-overlay__column-total"><div class="cart-summary-overlay__line-price">', lineHtml, '</div></div>',
            '</div>',
            '<div class="cart-summary-overlay__column-subtotal">',
              '<span class="cart-summary-overlay__subtotal theme-money">', money(cart ? cart.items_subtotal_price : item.final_line_price), '</span>',
              '<div class="cart-summary-overlay__note">', esc(str('products_added_notification_shipping_note', '')), '&nbsp;</div>',
            '</div>',
          '</div>',
          '<div class="cart-summary-overlay__actions">',
            '<a id="shop-more" class="button altcolour" href="#" data-pdp-notify-close>', esc(str('products_added_notification_keep_shopping', 'Keep shopping')), '</a>',
            '<a class="button to-cart" href="', esc((window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart'), '">', esc(str('products_added_notification_cart', 'View cart')), '</a>',
          '</div>'
        ].join('');

        this.hidden = false;
        // The theme dismisses a showing notification with
        // $('#cart-summary-overlay #shop-more').triggerHandler('click'), and
        // triggerHandler reaches jQuery handlers only — so bind one too, or a
        // legacy quickbuy adding to cart would stack its overlay on ours.
        if (window.jQuery) {
          window.jQuery(this).find('#shop-more').on('click', function (e) { e.preventDefault(); this.close(); }.bind(this));
        }
        window.addEventListener('scroll', this._onScroll, { passive: true, once: true });
      }
    });
  }

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function notifyAdded(item) {
    var el = document.querySelector('pdp-cart-notification');
    if (!el || typeof el.show !== 'function') return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { el.show(item, cart); })
      .catch(function () { el.show(item, null); });
  }

  /* --- Gallery --------------------------------------------------------- *
   * Desktop: the rail selects one stage slide. Mobile: the stage is a
   * horizontal scroll-snap carousel and the dots track scroll position.     */
  function initGallery(root) {
    $$('[data-pdp-gallery]', root).forEach(function (gal) {
      if (!once(gal, 'pdpGallery')) return;
      var stage = gal.querySelector('[data-pdp-stage]');
      var rail = gal.querySelector('[data-pdp-rail]');
      var dots = $$('.pdpg__dot', gal);
      if (!stage) return;

      var slides = $$('[data-pdp-slide]', stage);

      function select(id) {
        slides.forEach(function (s) { s.classList.toggle('pdpg__slide--active', s.dataset.pdpSlide === id); });
        $$('[data-pdp-thumb]', gal).forEach(function (t) {
          t.setAttribute('aria-current', t.dataset.pdpThumb === id ? 'true' : 'false');
        });
        var i = slides.findIndex(function (s) { return s.dataset.pdpSlide === id; });
        dots.forEach(function (d, di) { d.classList.toggle('pdpg__dot--on', di === i); });
        // On mobile the stage scrolls rather than swaps, so bring the slide into view
        if (i > -1 && getComputedStyle(stage).overflowX !== 'visible') {
          stage.scrollTo({ left: slides[i].offsetLeft - stage.offsetLeft, behavior: 'smooth' });
        }
      }

      $$('[data-pdp-thumb]', gal).forEach(function (t) {
        t.addEventListener('click', function () { select(t.dataset.pdpThumb); });
      });

      // Rail steppers, hidden entirely when there is nothing to scroll
      var railnav = gal.querySelector('.pdpg__railnav');
      function syncRail() {
        if (!rail) return;
        var slack = rail.scrollHeight - rail.clientHeight;
        if (railnav) railnav.hidden = slack < 2;
        $$('[data-pdp-rail-step]', gal).forEach(function (b) {
          b.disabled = parseInt(b.dataset.pdpRailStep, 10) < 0
            ? rail.scrollTop <= 1
            : rail.scrollTop >= slack - 1;
        });
      }
      if (rail) {
        $$('[data-pdp-rail-step]', gal).forEach(function (b) {
          b.addEventListener('click', function () {
            rail.scrollBy({ top: parseInt(b.dataset.pdpRailStep, 10) * 200, behavior: 'smooth' });
          });
        });
        rail.addEventListener('scroll', syncRail, { passive: true });
        window.addEventListener('resize', syncRail);
        syncRail();
      }

      // Mobile: keep the dots honest while the user swipes
      stage.addEventListener('scroll', function () {
        var i = Math.round(stage.scrollLeft / (stage.clientWidth || 1));
        dots.forEach(function (d, di) { d.classList.toggle('pdpg__dot--on', di === i); });
      }, { passive: true });

      // Follow colour changes so the gallery jumps to that colour's image.
      var form = document.querySelector('[data-pdp-form]');
      if (form) {
        form.addEventListener('pdp:variant', function (e) {
          var id = variantMedia(e.detail.variant);
          if (id && gal.querySelector('[data-pdp-slide="' + id + '"]')) select(id);
        });
      }
    });
  }

  /* --- Rating → reviews ----------------------------------------------- *
   * The reviews band is the `reviews` apps section in product.json, so its
   * id is shopify-section-template--<id>__reviews. Falls back to Yotpo's
   * widget in case the section is renamed. 56px clears the fixed top bar.  */
  function initReviewsLink(root) {
    $$('[data-pdp-reviews-link]', root).forEach(function (link) {
      if (!once(link, 'pdpReviews')) return;
      link.addEventListener('click', function (e) {
        var target = document.querySelector('[id^="shopify-section-"][id$="__reviews"]') ||
          document.querySelector('.yotpo-widget-instance, .yotpo-main-widget, .yotpo-reviews-main-widget');
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - 56;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* --- Short description ellipsis ------------------------------------- *
   * The truncated description's … opens the Description accordion row and
   * scrolls to it, with the same header allowance as the reviews link.      */
  function initDescriptionMore(root) {
    $$('[data-pdp-desc-more]', root).forEach(function (btn) {
      if (!once(btn, 'pdpDescMore')) return;
      btn.addEventListener('click', function () {
        var trigger = document.querySelector('[data-pdp-acc-description]');
        if (!trigger) return;
        if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
        var top = trigger.getBoundingClientRect().top + window.pageYOffset - 56;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* --- Sticky add-to-bag bar ------------------------------------------- */
  function initSticky(root) {
    $$('[data-pdp-sticky]', root).forEach(function (bar) {
      if (!once(bar, 'pdpSticky')) return;

      // The bar's own form repaints its button; the thumb and price sit
      // outside it, so follow its variant here. Liquid already opened both on
      // the selected variant, so this only runs on a change.
      var thumb = bar.querySelector('[data-pdp-sticky-thumb]');
      var price = bar.querySelector('.pdp-sticky__meta [data-pdp-price]');
      bar.addEventListener('pdp:variant', function (e) {
        var v = e.detail.variant;
        if (price) paintPrice(price, v);
        var id = variantMedia(v);
        var src = id && document.querySelector('[data-pdp-thumb="' + id + '"] img');
        if (thumb && src) thumb.src = src.getAttribute('src');
      });

      /* Publish the bar's height so the page and the floating widgets can
         clear it. Measured rather than hard-coded: the bar is a button on
         mobile and a card with a thumbnail on desktop, and it grows if the
         title wraps. Set even while the bar is out, so nothing jumps when it
         slides in. */
      function publishHeight() {
        var h = Math.round(bar.querySelector('.pdp-sticky__bar')
          ? bar.getBoundingClientRect().height
          : 0);
        if (h > 0) document.documentElement.style.setProperty('--pdp-atc-h', h + 'px');
      }
      publishHeight();
      window.addEventListener('resize', publishHeight);
      if ('ResizeObserver' in window) new ResizeObserver(publishHeight).observe(bar);

      var anchor = document.querySelector('[data-pdp-sticky-anchor]');
      if (!anchor || !('IntersectionObserver' in window)) { bar.classList.add('pdp-sticky--in'); return; }
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('pdp-sticky--in', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -80% 0px' }).observe(anchor);
    });
  }

  /* --- Yotpo loyalty floater clearance --------------------------------- *
   * Million Mile Club injects .yotpo-floater-widget-layout at the bottom.
   * Lift the sticky quick-shop bar above it when the widget is visible.   */
  function initYotpoFloaterClearance() {
    if (!once(document.documentElement, 'pdpYotpoClearance')) return;

    var SELECTOR = '.yotpo-floater-widget-layout';

    function floater() { return document.querySelector(SELECTOR); }

    function floaterVisible(el) {
      if (!el) return false;
      var s = getComputedStyle(el);
      if (s.display === 'none' || s.visibility === 'hidden') return false;
      if (parseFloat(s.opacity) === 0) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }

    function publish() {
      var offset = 0;
      if (floaterVisible(floater())) {
        /* Flush on the floater; .pdp-sticky bottom padding is the visual gap. */
        offset = Math.ceil(floater().getBoundingClientRect().height);
      }
      document.documentElement.style.setProperty('--pdp-yotpo-offset', offset + 'px');
    }

    function hook(el) {
      if (!el || el.dataset.pdpYotpoRo) return;
      el.dataset.pdpYotpoRo = '1';
      if ('ResizeObserver' in window) new ResizeObserver(publish).observe(el);
    }

    publish();
    window.addEventListener('resize', publish);
    hook(floater());
    new MutationObserver(function () {
      hook(floater());
      publish();
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* --- Sticky bar option sync ------------------------------------------ *
   * The sticky bar has its own quick-add form. On mobile its selects are
   * hidden, so it would sit on "Select a size" forever; mirror the main
   * picker into it instead. One-way: the buy box is the source of truth.   */
  function initStickySync() {
    var main = document.querySelector('.pdpm__card[data-pdp-form]');
    var sticky = document.querySelector('[data-pdp-sticky] [data-pdp-form]');
    if (!main || !sticky || !once(sticky, 'pdpSync')) return;

    function sync() {
      var chosen = readOptions(main);
      $$('[data-pdp-option]', sticky).forEach(function (el) {
        var v = chosen[parseInt(el.dataset.pdpOption, 10)];
        if (v === undefined || el.value === v) return;
        el.value = v;
        // Fire from the control itself so the form's own change handler repaints
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    main.addEventListener('pdp:variant', sync);
    // The buy box already painted once before this listener existed, so seed
    // the bar now — on mobile its selects are hidden and can never be set.
    sync();
  }

  /* --- Recommendations ------------------------------------------------- *
   * The section renders a collection-based grid so it is never empty, then
   * swaps in Shopify's real recommendations once they resolve.             */
  function initRecommendations(root) {
    $$('[data-section-type="pdp-recommendations"]', root).forEach(function (sec) {
      if (!once(sec, 'pdpRecs')) return;
      var url = sec.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.pdpr__grid');
          var grid = sec.querySelector('.pdpr__grid');
          if (fresh && grid && fresh.children.length) grid.replaceWith(fresh);
        })
        .catch(function () {});
    });
  }

  /* --- Video facade ----------------------------------------------------- *
   * The embed is only inserted on click, so YouTube/Vimeo's player script
   * never loads for the people who scroll past it.                          */
  function initVideo(root) {
    $$('[data-pdp-video-embed]', root).forEach(function (btn) {
      if (!once(btn, 'pdpVideo')) return;
      btn.addEventListener('click', function () {
        var frame = document.createElement('iframe');
        frame.src = btn.dataset.pdpVideoEmbed;
        frame.title = btn.getAttribute('aria-label') || 'Video';
        frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        frame.setAttribute('allowfullscreen', '');
        btn.parentNode.replaceChild(frame, btn);
      });
    });
  }

  function init(root) {
    initCarousels(root);
    initAccordions(root);
    initDisclosures(root);
    initQty(root);
    // Before initForms: its opening paint() dispatches pdp:variant, and the
    // gallery has to be listening by then or the page loads on the wrong slide.
    initGallery(root);
    initForms(root);
    initRecommendations(root);
    initVideo(root);
    initReviewsLink(root);
    initDescriptionMore(root);
    initSticky(root);
    initYotpoFloaterClearance();
    initStickySync();
  }

  window.PDP = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor: re-init whatever section was just re-rendered
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
